export default function MatrixInnerHolderComponent(params) {
    var self = null;
    var facade = null;
    var identifier = null;
    var elem = null;
    var builder = null;
    var navigator = null;
    var controls = null;
    var isTopbarActivated = false;
    var isBotbarActivated = false;

    var data = {};

    var containerSelector = null;
    var contentSelector = null;
    var contentHolder = null;
    var containerIdentifier = "inner_holder_container";

    var i = null;
    var j = null;

    var listeners = [];
    var containers = [];
    
    var defaultListener = null;
    var focused = false;
    var opened = false;
    var loaded = false;

    this.getI = function() {
        return i;
    }

    this.getJ = function() {
        return j;
    }

    this.set = function(oi, oj) {
        i = oi;
        j = oj;

        elem.attr("data-i", i);
        elem.attr("data-j", j);
    }

    this.matches = function(oi, oj) {
        if ((oi == i) && (oj == j))
            return true;

        return false;
    }

    this.getData = function() {
        return data;
    }

    this.setTitle = function(t) {
        self.getBuilder().setTitle(self, t);
    }

    this.getTitle = function() {
        return self.getBuilder().getParams().title;
    }

    this.getIdentifier = function() {
        return identifier;
    }

    this.setIdentifier = function(i) {
        identifier = i;
    }

    this.addListener = function(listener) {
        listeners.push(listener);
    }

    this.removeListener = function(listener) {
        listeners.removeItem(listener);
    }

    this.addContainer = function(container) {
        containers.push(container);
        container.addListener(defaultListener);
        
        container.getElement().addClass(containerIdentifier);
        contentHolder.append(container.getElement());
        container.setHolder(self);
    
        return container;
    }

    this.removeContainer = function(container) {
        containers.removeItem(container);
        container.clear();
        container.setHolder(null);
        
        self.getElement().removeClass(containerIdentifier);
        
        // container.removeListener(defaultListener);
        
        return container;
    }

    this.getContainers = function() {
        return containers;
    }

    this.getFirstContainer = function() {
        return containers.length == 0 ? null : containers[0];
    }

    this.clear = function() {
        contentHolder.find("." + containerIdentifier).remove();
    }

    this.clearExcept = function(except) {
        contentHolder.find("." + containerIdentifier).not(except).remove();
    }

    this.getElement = function() {
        return elem;
    }

    this.setBuilder = function(b) {
        builder = b;
    }

    this.getBuilder = function() {
        return builder;
    }

    this.setControls = function(c) {
        controls = c;
    }

    this.getControls = function() {
        return controls;
    }

    this.setNavigator = function(n) {
        navigator = n;
    }

    this.getNavigator = function() {
        return navigator;
    }

    this.getBotbarActivated = function() {
        return isBotbarActivated;
    }

    this.setBotbarActivated = function(ita) {
        isBotbarActivated = ita;
    }


    this.getTopbarActivated = function() {
        return isTopbarActivated;
    }

    this.setTopbarActivated = function(ita) {
        isTopbarActivated = ita;
    }

    this.getContentSelector = function() {
        return contentSelector;
    }

    this.getContainerSelector = function() {
        return containerSelector;
    }

    this.setContainerSelector = function(cs) {
        containerSelector = cs;

        elem = $(containerSelector);
    }

    this.setContentSelector = function(cs) {
        contentSelector = cs;

        contentHolder = elem.find(contentSelector);
    }

    this.create = function() {
        elem = builder.build(self);

        self.setContentSelector(contentSelector);

        containers.forEach(function(container){
            contentHolder.append(container.getElement());
        });

        listeners.forEach(function(listener) {
            if (!!listener.onCreateView)
                listener.onCreateView(self);
        });
    }

    this.initialize = function() {
        listeners.forEach(function(listener) {
            if (!!listener.onInitView)
                listener.onInitView(self);
        });

        elem.data("component", self);
    }

   

    this.setFocused = function(f) {
        focused = f;

        if (elem != null) {
            if (focused)
                elem.addClass("focused");
            else
                elem.removeClass("focused");
        }

        listeners.forEach(function(listener) {
            if (focused)
                if (!!listener.viewDidFocus)
                    listener.viewDidFocus(self);
            else
                if (!!listener.viewDidBlur)
                    listener.viewDidBlur(self);
        });
    }

    this.getOpened = function() {
        return opened;
    }

    this.getFocused = function() {
        return focused;
    }

    this.getFacade = function() {
        return facade;
    }

    this.open = function() {
        containers.forEach(function(container) {
            if (!!container && !container.isAlreadyLoaded()) {
                self.reload();
    
                self.didOpen(self, container);
            }
        });
    }

    this.close = function() {
        containers.forEach(function(container) {
            self.didClose(self, container);
        });
    }
    
    this.reload = function() {
        containers.forEach(function(container) {
            if (!!container)
                
                setTimeout(function () {
                    container.getProxy().execute();
                }, 250);
        });
    }
    
    this.unload = function() {
        containers.forEach(function(container) {
            self.removeContainer(container);
            self.clear();
            self.didUnload(self, container);
        });
    }

    this.didAttachToWindow = function(wf) {
        facade = wf;

        builder.afterAttach(self);
    }

    this.didOpen = function(h, container) {
        builder.animateIn(self);

        opened = true;
        
        listeners.forEach(function(listener) {
            if (!!listener.didOpen)
                listener.didOpen(h, container);
        });
    }
    
    this.isLoaded = function() {
        return loaded;
    }
    
    this.didLoad = function(h, container) {
        loaded = true;
        
        listeners.forEach(function(listener) {
            if (!!listener.didLoad)
                listener.didLoad(self, container);
        });
    }
    
    this.didUpdate = function(h, container) {
        listeners.forEach(function(listener) {
            if (!!listener.didUpdate)
                listener.didUpdate(self, container);
        });
    }
    
    this.didUnload = function(container) {
        loaded = false;
        
        listeners.forEach(function(listener) {
            if (!!listener.didUnload)
                listener.didUnload(self, container);
        });
    }

    this.didClose = function(h, container) {
        builder.animateOut(h);

        opened = false;

        listeners.forEach(function(listener) {
            if (!!listener.didClose)
                listener.didClose(h, container);
        });
    }
    
    this.onMove = function(s,t, sl, st) {
        listeners.forEach(function(listener) {
            if (!!listener.onMove)
                listener.onMove(s,t, sl, st);
        });
    }
    
    this.didMoveIn = function(s,t) {
        listeners.forEach(function(listener) {
            if (!!listener.didMoveIn)
                listener.didMoveIn(s,t);
        });
    }
    
    this.didMoveOut = function(s,t) {
        listeners.forEach(function(listener) {
            if (!!listener.didMoveOut)
                listener.didMoveOut(s,t);
        });
    }

    var __construct = function (that) {
        self = that;
        identifier = params.identifier;
        builder = params.builder;
        navigator = params.navigator;
        controls = params.controls;
        isTopbarActivated = !!params.isTopbarActivated;
        isBotbarActivated = !!params.isBotbarActivated;
        self.setContainerSelector(params.containerSelector);
        self.setContentSelector(params.contentSelector);
    
        defaultListener = {
            onCreate: function(holder, container) {
            },
            onAttach: function(h, container) {
            },
            onDetach: function(h, container) {
            },
            didLoad: function(container) {
                self.didLoad(self, container);
            },
            didUpdate: function(container) {
                self.didUpdate(self, container);
            },
            didMove: function(from, to) {
            }
        }
    }(this)
}